import React, { useContext } from 'react';
import { View } from '@coinscrap/webapp-core';

import InputLabel from 'components/InputLabel/InputLabel';
import { SpanCurrency } from 'components/SpanCurrency/SpanCurrency';

import { getCurrency } from 'helpers/currency';
import { AgentContext } from '../../../contexts/agent';

export const CapitalOther = ({
	capital,
	isValidCapital,
	setIsValidCapital,
	setInvalidCapitalReason,
	otherCapital,
	setOtherCapital,
	capitalMaximum,
	capitalMinimum,
	otherCapitalInputWidth,
	setShowKoLink,
}) => {
	const { agent } = useContext(AgentContext);
	return (
		<View inputFreeRowSt>
			{capital === 'Otros' && (
				<InputLabel
					type="currency"
					style={{
						marginTop: -20,
						input: {
							width: otherCapitalInputWidth + 'ch',
							border: '0px',
						},
					}}
					value={getCurrency(otherCapital, 0, true) || ''}
					onChange={(e) => {
						const newCapital = e.target.value || '';
						const val = newCapital.replace(/\D/g, '');
						setIsValidCapital(
							val !== '' && val <= capitalMaximum && val >= capitalMinimum,
						);
						setShowKoLink(false);
						if (val > capitalMaximum) {
							setInvalidCapitalReason(
								`El capital máximo asegurable es de ${getCurrency(
									capitalMaximum,
									0,
								)}. Si deseas asegurar un capital superior, `,
							);
							setShowKoLink(true);
						} else if (val === '' || val < capitalMinimum) {
							setInvalidCapitalReason(
								`Lo sentimos, con los datos introducidos no podemos calcular tu prima. Aumenta el capital a asegurar para continuar con la contratación.`,
							);
							setShowKoLink(false);
						}
						setOtherCapital(val);
					}}
					currencyItem={<SpanCurrency>€</SpanCurrency>}
					errorMsg={
						(!isValidCapital &&
							otherCapital < capitalMinimum &&
							`El capital asegurado debe ser superior a ${getCurrency(
								capitalMinimum,
								0,
							)} para poder continuar con la cotización.`) ||
						(!isValidCapital &&
							otherCapital > capitalMaximum &&
							`El capital máximo asegurable es de ${getCurrency(
								capitalMaximum,
								0,
							)}. Si deseas asegurar un capital superior, llámanos${
								agent.identifier === 'bmw' || agent.identifier === 'rastreator'
									? ''
									: ' o te llamamos'
							}.`)
					}
				/>
			)}
		</View>
	);
};
